<template>

    <div id="project" class="row">

        <form id="project-form" action="" method="post" enctype="multipart/form-data">
            <input type="hidden" name="mb_no" :value="company_id">
            <input v-if="mode === 'edit'" type="hidden" name="_method" value="put">

            <div v-if="show_title" class="col-xs-12">
                <h1 class="mb-4 pb-4 border-b">프로젝트
                    <small v-if="mode === 'create'">생성하기</small>
                    <small v-if="mode === 'edit'">수정하기</small>
                    <small v-if="mode === 'view-detail'">상세보기</small>
                    <small v-if="mode === 'view-summary'">요약보기</small>
                </h1>
            </div>

            <div class="col-xs-12" v-if="is_admin || project.mb_no == user_id">

                <div class="pb-4 mb-4 border-b">
                    <div class="row">

                        <div v-if="! is_admin && project.project_status == 'request'">

                            <div class="col-xs-12">
                                <div class="pb-2 mb-2 border-b">
                                    <div class="alert alert-success" role="alert">심사중입니다.</div>
                                </div>
                            </div>

                            <div class="col-xs-12 mt-1 mb-1 xs-text-left text-right">
                                <button v-if="is_admin" @click.prevent="deleteProject" class="btn btn-danger btn-sm">프로젝트 삭제</button>
                                <div v-if="is_admin || project.mb_no == user_id " class="btn-group" role="group" aria-label="...">
                                    <button type="button" class="btn btn-default btn-sm"
                                            :class="{ 'btn-primary': mode === 'edit' }"
                                            @click="mode = 'edit'">수정</button>
                                    <button type="button" class="btn btn-default btn-sm"
                                            :class="{ 'btn-primary': mode === 'view-summary' }"
                                            @click="mode = 'view-summary'">요약보기</button>
                                    <button type="button" class="btn btn-default btn-sm"
                                            :class="{ 'btn-primary': mode === 'view-detail' }"
                                            @click="mode = 'view-detail'">상세보기</button>
                                </div>
                            </div>
                        </div>

                        <div v-else-if=" ! is_admin && project.project_status == 'request_fail'" class="col-xs-12">
                            <div class="alert alert-success" role="alert">프로젝트 신청이 거부되었습니다.</div>
                        </div>

                        <div v-else>
                            <div v-if="mode == 'edit' && ( is_admin || project.mb_no == user_id)" class="col-xs-12 col-md-3 mt-1 mb-1">

                                <select class="form-control"
                                        v-model="project.project_status"
                                        @change="onChangeProjectStatus($event)">

                                    <option v-if="is_admin" value="request">프로젝트 신청</option>
                                    <option v-if="is_admin" value="request_fail">프로젝트 신청 거부</option>
                                    <option v-if="is_admin" value="request_pass">프로젝트 신청 승인</option>
                                    <option v-if=" ! is_admin && project.project_status == 'request'" value="request" disabled>프로젝트 준비 중</option>
                                    <option v-if=" ! is_admin && project.project_status == 'request_fail'" value="request_fail" disabled>프로젝트 준비 중</option>
                                    <option v-if=" ! is_admin && project.project_status == 'request_pass'" value="request_pass" disabled>프로젝트 준비 중</option>
                                    <option value="recruiting">테스터 모집 중</option>
                                    <option value="recruiting_done">테스터 모집 완료</option>
                                    <option value="testing">테스트 진행</option>
                                    <option value="testing_done">테스트 완료</option>
                                    <option value="appraisal">평가 중</option>
                                    <option value="done">완료</option>

                                </select>

                            </div>
                            <div class="col-xs-12 mt-1 mb-1" :class="{ 'col-md-4': mode == 'edit', 'col-md-7': mode !== 'edit' }">
                                <div v-if="project.project_status != 'request' && project.project_status != 'request_fail'">
                                    <div v-if="is_admin || project.mb_no == user_id" class="btn-group" role="group" aria-label="...">
                                        <a :href="'/my/service/message?who=' + project_id" class="btn btn-default btn-sm">이메일/문자 전송</a>
                                    </div>
                                    <a v-if="is_admin || project.mb_no == user_id" :href="'/bbs/board.php?bo_table=project_issues&project_id=' + project_id" class="btn btn-default btn-sm">이슈보기</a>
                                    <a v-if="is_admin || project.mb_no == user_id" :href="'/projects/' + project_id + '/issues/export/excel'" class="btn btn-default btn-sm" target="_blank">이슈 내보내기</a>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-5 mt-1 mb-1 xs-text-left text-right">
                                <button v-if="is_admin" @click.prevent="deleteProject" class="btn btn-danger btn-sm">프로젝트 삭제</button>
                                <div v-if="is_admin || project.mb_no == user_id " class="btn-group" role="group" aria-label="...">
                                    <button type="button" class="btn btn-default btn-sm"
                                            :class="{ 'btn-primary': mode === 'edit' }"
                                            @click="mode = 'edit'">수정</button>
                                    <button type="button" class="btn btn-default btn-sm"
                                            :class="{ 'btn-primary': mode === 'view-summary' }"
                                            @click="mode = 'view-summary'">요약보기</button>
                                    <button type="button" class="btn btn-default btn-sm"
                                            :class="{ 'btn-primary': mode === 'view-detail' }"
                                            @click="mode = 'view-detail'">상세보기</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div :class="{ 'col-xs-12' : mode == 'view-summary', 'col-xs-12 col-md-8' : mode != 'view-summary' }">

                <!--프로젝트 기본정보-->
                <div class="panel panel-default">
                    <div class="panel-heading">
                        프로젝트 기본정보
                    </div>
                    <div class="panel-body">

                        <div class="form-group">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  신청 기업명</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <input type="text" class="form-control" v-model="company.mb_name" readonly>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                <span>{{ company.mb_name }}</span>

                            </div>


                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('title')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  프로젝트 명칭</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <input type="text" name="title" class="form-control"
                                       v-model="project.title"
                                       :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                       data-vv-as="'프로젝트 명칭'"
                                       v-validate="'required'">

                                <span class="text-danger"
                                      v-show="errors.has('title')">{{ errors.first('title') }}</span>
                                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                                      v-show="errors.has('title')"></span>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                <span style="word-wrap: break-word">{{ project.title }}</span>

                            </div>


                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('description')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  프로젝트 개요</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <textarea name="description" class="form-control" rows="10"
                                          :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                          data-vv-as="'프로젝트 개요'"
                                          v-validate="'required'">{{ project.description }}</textarea>

                                <span class="text-danger"
                                      v-show="errors.has('description')">{{ errors.first('description') }}</span>
                                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                                      v-show="errors.has('description')"></span>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                <div style="word-wrap: break-word" v-html="project.description.replace(/\n/g, '<br />')"></div>

                            </div>
                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('project_target')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  프로젝트 대상</label>

                            <div>
                                <label v-for="(environment, index) in environments" class="mr-3">
                                    <input name="project_target" type="radio"
                                           :value="environment.id"
                                           :disabled="mode === 'view-summary' || mode === 'view-detail'"
                                           v-model="project.project_target"
                                           data-vv-as="'프로젝트 대상'"
                                           v-validate="'required'">
                                    <span>{{ environment.title }}</span>
                                </label>
                            </div>

                            <span class="text-danger"
                                  v-show="errors.has('project_target')">{{ errors.first('project_target') }}</span>
                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('testing_purpose[]')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  프로젝트 유형</label>

                            <div>
                                <label v-for="purpose in testing_purpose" class="mr-3">
                                    <input name="testing_purpose[]" type="checkbox"
                                           :value="purpose.value"
                                           :disabled="mode === 'view-summary' || mode === 'view-detail'"
                                           v-model="project.testing_purpose"
                                           data-vv-as="'프로젝트 유형'"
                                           v-validate="'required'">
                                    <span>{{ purpose.title }}</span>
                                </label>
                            </div>
                            <span class="text-danger"
                                  v-show="errors.has('testing_purpose[]')">{{ errors.first('testing_purpose[]') }}</span>
                        </div>

                    </div>
                </div>

                <!--담당자 정보-->
                <div class="panel panel-default">
                    <div class="panel-heading">
                        담당자
                    </div>
                    <div class="panel-body">

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('staff_name')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  담당자 이름</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <input type="text" name="staff_name" class="form-control"
                                       v-model="project.staff_name"
                                       :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                       data-vv-as="'담당자 이름'"
                                       v-validate="{ required: true, regex: /^[가-힣a-zA-Z]+$/ }">

                                <span class="text-danger"
                                      v-show="errors.has('staff_name')">{{ errors.first('staff_name') }}</span>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">
                                <span>{{ project.staff_name }}</span>
                            </div>


                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('staff_tel')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  담당자 연락처</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <input type="text" name="staff_tel" class="form-control"
                                       v-model="project.staff_tel"
                                       :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                       data-vv-as="'담당자 연락처'"
                                       v-validate="'required|numeric'">

                                <span class="text-danger"
                                      v-show="errors.has('staff_tel')">{{ errors.first('staff_tel') }}</span>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                <span>{{ project.staff_tel }}</span>

                            </div>

                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('staff_email')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  담당자 이메일</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <input type="text" name="staff_email" class="form-control"
                                       v-model="project.staff_email"
                                       :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                       data-vv-as="'담당자 이메일'"
                                       v-validate="'required|email'">

                                <span class="text-danger"
                                      v-show="errors.has('staff_email')">{{ errors.first('staff_email') }}</span>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                <span>{{ project.staff_email }}</span>

                            </div>

                        </div>

                        <div class="form-group"
                             v-bind:class="{'has-error has-feedback': errors.has('staff_tel_time_start') || errors.has('staff_tel_time_start')}">

                            <label class="label-title"><i class="fas fa-hashtag"></i>  담당자 연락 가능시간</label>

                            <div v-if="mode === 'create' || mode === 'edit'">

                                <div class="row">
                                    <div class="col-xs-6">

                                        <div class="input-group">
                                            <select name="staff_tel_time_start" class="form-control"
                                                    v-model="project.staff_tel_time_start"
                                                    :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                                    data-vv-as="'담당자 연락 가능시간'"
                                                    v-validate="'required'">

                                                <option v-for="index in 24" :value="index">{{ '2018-01-01 ' + ("0" + index).slice(-2) + ':00:00' | moment_format_LT }}시</option>
                                            </select>
                                            <span class="input-group-addon">부터</span>
                                        </div>

                                        <span class="text-danger"
                                              v-show="errors.has('staff_tel_time_start')">{{ errors.first('staff_tel_time_start') }}</span>
                                    </div>
                                    <div class="col-xs-6">
                                        <div class="input-group">
                                            <select name="staff_tel_time_end" class="form-control"
                                                    v-model="project.staff_tel_time_end"
                                                    :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                                    data-vv-as="'담당자 연락 가능시간'"
                                                    v-validate="'required|min_value:' + parseInt(project.staff_tel_time_start)">

                                                <option v-for="index in 24" :value="index">{{ '2018-01-01 ' + ("0" + index).slice(-2) + ':00:00' | moment_format_LT }}시</option>
                                            </select>

                                            <span class="input-group-addon">까지</span>
                                        </div>

                                        <span class="text-danger"
                                              v-show="errors.has('staff_tel_time_end')">{{ errors.first('staff_tel_time_end') }}</span>
                                    </div>
                                </div>

                            </div>
                            <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                <span>
                                    {{ getTimeFormat(project.staff_tel_time_start) | moment_format_LT }}
                                    ~
                                    {{ getTimeFormat(project.staff_tel_time_end) | moment_format_LT}}
                                </span>

                            </div>



                        </div>

                    </div>
                </div>

                <!--프로젝트 모집정보-->
                <div class="panel panel-default">
                    <div class="panel-heading">
                        프로젝트 모집정보
                    </div>
                    <div class="panel-body">

                        <div class="form-group">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  모집 인원</label>
                            <div class="row mt-2">

                                <div v-if="mode === 'create' || mode === 'edit'">

                                    <div class="col-xs-6">

                                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('expert_tester')}">
                                            <label >전문테스터</label>
                                            <input type="number" name="expert_tester" class="form-control"
                                                   v-model="project.expert_tester"
                                                   :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                                   data-vv-as="'전문 테스터'"
                                                   v-validate="'required|min_value:0|max_value:1000'">

                                            <span class="text-danger"
                                                  v-show="errors.has('expert_tester')">{{ errors.first('expert_tester') }}</span>
                                        </div>

                                    </div>
                                    <div class="col-xs-6">

                                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('normal_tester')}">
                                            <label >일반테스터</label>
                                            <input type="number" name="normal_tester" class="form-control"
                                                   v-model="project.normal_tester"
                                                   :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                                   data-vv-as="'일반 테스터'"
                                                   v-validate="'required|min_value:0|max_value:1000'">

                                            <span class="text-danger"
                                                  v-show="errors.has('normal_tester')">{{ errors.first('normal_tester') }}</span>
                                        </div>

                                    </div>

                                </div>
                                <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                    <div class="col-xs-12">
                                        <ul class="list-unstyled">
                                            <li>전문테스트 모집 인원: {{ project.expert_tester }} 명</li>
                                            <li>일반테스트 모집 인원: {{ project.normal_tester }} 명</li>
                                        </ul>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('application_start') || errors.has('application_end')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  모집 기간</label>
                            <div class="row">
                                <div v-if="mode === 'create' || mode === 'edit'">

                                    <div class="col-xs-6">
                                        <input type="hidden" name="application_start" class="form-control"
                                               v-model="application_start.time"
                                               :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                               data-vv-as="'모집 기간 시작일'"
                                               v-validate="'required'">

                                        <date-picker :date="application_start" :option="date_picker_option"></date-picker>

                                        <span class="text-danger"
                                              v-show="errors.has('application_start')">{{ errors.first('application_start') }}</span>
                                    </div>
                                    <div class="col-xs-6">
                                        <input type="hidden" name="application_end" class="form-control"
                                               v-model="application_end.time"
                                               :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                               data-vv-as="'모집 기간 종료일'"
                                               v-validate="'required|afterDate:' + application_start.time">

                                        <date-picker :date="application_end" :option="date_picker_option"></date-picker>

                                        <span class="text-danger"
                                              v-show="errors.has('application_end')">{{ errors.first('application_end') }}</span>
                                    </div>

                                </div>
                                <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                    <div class="col-xs-12">
                                        {{ application_start.time | moment_format_LL }} ~ {{ application_end.time | moment_format_LL }}
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <!--프로젝트 진행정보-->
                <div class="panel panel-default">
                    <div class="panel-heading">
                        프로젝트 진행정보
                    </div>
                    <div class="panel-body">

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('testing_start') || errors.has('testing_end')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i>  진행 기간</label>
                            <div class="row">

                                <div v-if="mode === 'create' || mode === 'edit'">

                                    <div class="col-xs-6">
                                        <input type="hidden" name="testing_start" class="form-control"
                                               v-model="testing_start.time"
                                               :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                               data-vv-as="'진행 시작일'"
                                               v-validate="'required|afterDate:' + application_end.time">

                                        <date-picker :date="testing_start" :option="date_picker_option"></date-picker>

                                        <span class="text-danger"
                                              v-show="errors.has('testing_start')">{{ errors.first('testing_start') }}</span>
                                    </div>
                                    <div class="col-xs-6">
                                        <input type="hidden" name="testing_end" class="form-control"
                                               v-model="testing_end.time"
                                               :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                               data-vv-as="'진행 종료일'"
                                               v-validate="'required|afterDate:' + testing_start.time">

                                        <date-picker :date="testing_end" :option="date_picker_option"></date-picker>

                                        <span class="text-danger"
                                              v-show="errors.has('testing_end')">{{ errors.first('testing_end') }}</span>
                                    </div>

                                </div>
                                <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                    <div class="col-xs-12">
                                        {{ testing_start.time | moment_format_LL }} ~ {{ testing_end.time | moment_format_LL }}
                                    </div>

                                </div>



                            </div>
                        </div>

                    </div>
                </div>

                <!--프로젝트 보상정보-->
                <div class="panel panel-default">
                    <div class="panel-heading">
                        프로젝트 보상정보
                    </div>
                    <div class="panel-body">

                        <div class="form-group" v-bind:class="{'has-error has-feedback': errors.has('reward') || errors.has('reward')}">
                            <label class="label-title"><i class="fas fa-hashtag"></i> 보상 정보</label>
                            <div class="row">

                                <div v-if="mode === 'create' || mode === 'edit'">

                                    <div class="col-xs-12">
                                        <textarea name="reward" class="form-control" rows="10"
                                               v-model="project.reward"
                                               :readonly="mode === 'view-summary' || mode === 'view-detail'"
                                               data-vv-as="'프로젝트 보상정보'"
                                               v-validate="''"></textarea>

                                        <span class="text-danger"
                                              v-show="errors.has('project-reward')">{{ errors.first('reward') }}</span>
                                    </div>

                                </div>
                                <div v-if="mode === 'view-summary' || mode === 'view-detail'">

                                    <div class="col-xs-12" v-html="project.reward == '' ? '보상 정보가 없습니다.' : project.reward.replace(/\n/g, '<br />')"></div>

                                </div>



                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="mode === 'create'">

                    <device v-for="device in devices"
                            ref="device"
                            :key="device.seq_id"
                            related-with="project"
                            related-id=""
                            :environment-id="project.project_target"
                            async-create="false"
                            @deleted="onDeletedDeviceOfCreateMode(device.seq_id)"></device>

                    <button v-if="device_max_count > devices.length" class="btn btn-primary btn-block" @click.prevent="addDevice">device 추가</button>

                    <div id="device-input-wrap"></div>

                </div>

                <div v-if="mode === 'edit'">

                    <device v-for="device in devices"
                            ref="device"
                            :key="device.id"
                            related-with="project"
                            :related-id="project_id"
                            :environment-id="project.project_target"
                            :device-id="device.id"
                            @deleted="onDeletedDeviceOfEditMode(device.id)"></device>

                    <button v-if="device_max_count > devices.length" class="btn btn-primary btn-block" @click.prevent="addDevice">device 추가</button>

                </div>

                <div v-if="mode === 'view-detail'">

                    <device v-for="device in devices"
                            :key="device.id"
                            related-with="project"
                            :related-id="project_id"
                            :environment-id="project.project_target"
                            :device-id="device.id" readonly="true"></device>

                </div>

                <div v-if="mode === 'view-summary'">

                    <device v-for="device in devices"
                            :key="device.id"
                            related-with="project"
                            :related-id="project_id"
                            :environment-id="project.project_target"
                            :device-id="device.id" readonly="true"></device>

                </div>

            </div>

            <div v-if="mode === 'create' || mode === 'edit' || mode === 'view-detail'" class="col-xs-12 col-md-4">

                <div  v-if="mode === 'create' || mode === 'edit'" class="pb-4 mb-4 border-b">
                    <button type="submit" class="btn btn-primary btn-block"
                            @click.prevent="validateBeforeSubmit">
                        프로젝트
                        <span v-if="mode === 'create'">등록</span>
                        <span v-if="mode === 'edit'">수정</span>
                    </button>
                </div>

                <!--프로젝트 관련 자료-->

                <div class="form-group">
                    <label class="label-title"><i class="fas fa-hashtag"></i>  프로젝트 스크린샷</label>
                    <div id="attachment-screenshot-wrap">

                        <ul class="list-unstyled" v-if="mode === 'create'" v-for="index in screenshot_count">
                            <li><input type="file" name="screenshot[]" class="mb-1"></li>
                        </ul>

                        <attachments v-else
                                     related-with="Project"
                                     :related-id="project_id"
                                     attachment-type="screenshot"
                                     :attachment-mode="mode === 'view-summary' || mode === 'view-detail' ? 'list' : 'manager'"></attachments>

                    </div>

                    <button class="btn btn-default btn-block btn-sm mt-4"
                            v-if="mode === 'create'"
                            @click.prevent="addAttachment('screenshot')">스크린샷 추가</button>

                    <hr>

                    <label class="label-title"><i class="fas fa-hashtag"></i>  매뉴얼 또는 테스트 지침서</label>
                    <div id="attachment-manual-wrap">

                        <ul class="list-unstyled" v-if="mode === 'create'" v-for="index in manual_count">
                            <li><input type="file" name="manual[]" class="mb-1"></li>
                        </ul>

                        <attachments v-else
                                     related-with="Project"
                                     :related-id="project_id"
                                     attachment-type="manual"
                                     :attachment-mode="mode === 'view-summary' || mode === 'view-detail' ? 'list' : 'manager'"></attachments>
                    </div>

                    <button class="btn btn-default btn-block btn-sm mt-4"
                            v-if="mode === 'create'"
                            @click.prevent="addAttachment('manual')">매뉴얼 추가</button>

                    <hr>

                    <label class="label-title"><i class="fas fa-hashtag"></i>  관련 자료 업로드</label>
                    <div id="attachment-reference-wrap">

                        <ul class="list-unstyled" v-if="mode === 'create'" v-for="index in reference_count">
                            <li><input type="file" name="reference[]" class="mb-1"></li>
                        </ul>

                        <attachments v-else
                                     related-with="Project"
                                     :related-id="project_id"
                                     attachment-type="reference"
                                     :attachment-mode="mode === 'view-summary' || mode === 'view-detail' ? 'list' : 'manager'"></attachments>
                    </div>

                    <button class="btn btn-default btn-block btn-sm mt-4"
                            v-if="mode === 'create'"
                            @click.prevent="addAttachment('reference')">관련자료 추가</button>


                    <hr>

                    <label class="label-title"><i class="fas fa-hashtag"></i>  관련 자료 링크</label>
                    <div id="link-wrap">

                        <ul class="list-group">
                            <li class="list-group-item" v-for="(link, index) in project.link">
                                <input type="text" name="link[]" class="form-control mb-1"
                                       v-if="mode === 'create' || mode === 'edit'"
                                       v-model="project.link[index]">
                                <a :href="sterilizeLink(link)"
                                   v-if="mode === 'view-summary' || mode === 'view-detail'"
                                   v-text="link" target="_blank"></a>
                            </li>
                        </ul>

                    </div>
                    <button class="btn btn-default btn-block btn-sm mt-4"
                            v-if="mode === 'create' || mode === 'edit'"
                            @click.prevent="addLink">링크 추가</button>
                </div>

                <ul class="text-left pl-4">
                    <li>관련 자료 업로드에는 평가할 SW, APP 등 직접 배포할 자료를 업로드합니다.</li>
                    <li>
                        관련 자료 링크에는 테스트에 참고가 되는 웹사이트, 동영상, 랑크 등을 등록합니다.
                        WEB 테스트의 경우 평가 대상 사이트의 링크를 등록합니다.
                    </li>
                </ul>


            </div>

        </form>

    </div>

</template>

<script>

    import Attachments from './Attachments';
    import Datepicker from 'vue-datepicker';
    import moment from 'moment';

    export default {
        name: "project",
        props: ['projectMode', 'companyId', 'projectId', 'isAdmin', 'userId', 'showTitle'],
        components: {
            'attachments': Attachments,
            'date-picker': Datepicker,
        },
        data() {
            return {
                mode: "",
                is_admin: false,
                user_id: "",
                company_id: "",
                company: "",
                project_id: "",
                environments: "",
                project: {
                    id: "",
                    mb_no: "",
                    project_status: "",
                    staff_name: "",
                    staff_tel: "",
                    staff_email: "",
                    staff_tel_time_start: "",
                    staff_tel_time_end: "",
                    title: "",
                    description: "",
                    project_target: "",
                    testing_purpose: [],
                    normal_tester: "",
                    expert_tester: "",
                    application_start: "",
                    application_end: "",
                    testing_start: "",
                    testing_end: "",
                    reward: "",
                    memo: "",
                    created_at: "",
                    updated_at: "",
                    link: [],
                },
                devices: [],
                attachments: [],
                testing_purpose: [
                    {title: '호환성 테스트', value: 'compatibility'},
                    {title: '사용성 테스트', value: 'usage'},
                    {title: '기능성 테스트', value: 'feature'},
                    {title: '기타(상담)', value: 'etc'}
                ],
                project_environment: "",
                device_max_count: 6,

                show_title: true,

                added_screenshot: [],
                screenshot_max_count: 4,
                screenshot_count: 1,

                added_manual: [],
                manual_max_count: 4,
                manual_count: 1,

                added_reference: [],
                reference_max_count: 4,
                reference_count: 1,

                added_link: [],
                link_max_count: 4,
                link_count: 1,

                application_start: { time: "" },
                application_end: { time: "" },
                testing_start: { time: "" },
                testing_end: { time: "" },

                date_picker_option: {
                    type: 'day',
                    week: ['월', '화', '수', '목', '금', '토', '일'],
                    month: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                    format: 'YYYY-MM-DD',
                    placeholder: '날짜를 선택하세요.',
                    buttons: {
                        ok: '확인',
                        cancel: '취소'
                    },
                }
            }
        },
        created() {

            this.mode   = this.projectMode;
            this.is_admin = this.isAdmin == "true" ? true : false;
            this.user_id = this.userId;
            this.company_id     = this.companyId;

            this.show_title = this.showTItle == "true" ? true : false;

            if (this.projectId !== undefined || this.projectId === "") {
                this.project_id     = parseInt(this.projectId);
            }

            if (this.mode === undefined || this.company_id === undefined) {
                // 필수 데이터 부족
            }

            this.getEnvironments();

            if (this.companyId !== undefined) {
                this.getCompany();
            }

            if ( this.project_id !== "" ) {
                this.getProject();
            }
        },
        watch: {
            projectId(new_project_id, old_project_id) {
                this.project_id = this.projectId;
                this.mode = this.projectMode;
                this.getProject();
            },
            projectMode(new_mode, old_mode) {
                this.mode = this.projectMode
            }
        },
        computed: {

            screenshots() {
                let saved_screentshot = _.filter(this.attachments, (attachment) => {
                    return attachment.type === "screenshot";
                });

                return _.merge(saved_screentshot, this.added_screenshot);
            },
            manuals() {
                let saved_manual = _.filter(this.attachments, (attachment) => {
                    return attachment.type === "manual";
                });

                return _.merge(saved_manual, this.added_manual);
            },
            references() {
                let saved_reference = _.filter(this.attachments, (attachment) => {
                    return attachment.type === "reference";
                });

                return _.merge(saved_reference, this.added_reference);
            },
            links() {
                var saved_link = _.slice(this.project.link, 0);

                _.each(this.added_link, function ($link) {
                    saved_link.push($link);
                })

                return saved_link;
            },

        },
        methods: {
            onChangeProjectStatus(event) {
                let selected_status = event.target.value;

                if (selected_status == "ready") return;

                $.ajax({
                    url: '/project/' + this.project.id + '/status',
                    method: 'post',
                    data: { _method: 'put', status: selected_status }
                })
                .done((response) => {
                    this.$emit('changed_project_status');
                })
            },
            getEnvironments() {

                $.ajax({
                    url: '/device/meta/type/environment',
                    method: 'get',
                })
                .done((response) => {
                    this.environments = response;
                })

            },
            getCompany() {

                $.ajax({
                    url: '/user/' + this.company_id,
                    method: 'get',
                    async: false,
                })
                .done((response) => {
                    this.company = response;
                })

            },
            getProject() {

                $.ajax({
                    url: '/project/' + this.project_id,
                    data: {is_ajax: true},
                    method: 'get',
                })
                .done((response) => {
                    this.project        = response.project;
                    this.devices        = response.devices;
                    this.attachments    = response.attachments;
                    this.company        = response.company;
                    this.company_id     = response.company.mb_no;

                    this.application_start.time  = this.project.application_start.slice(0, 10);
                    this.application_end.time    = this.project.application_end.slice(0, 10);
                    this.testing_start.time      = this.project.testing_start.slice(0, 10);
                    this.testing_end.time        = this.project.testing_end.slice(0, 10);
                })

            },
            addDevice() {

                if (this.project.project_target == "") {
                    return alert("프로젝트 대상을 선택하세요.")
                }

                let not_validated_devices = _.filter(this.$refs.device, (device) => {
                    return ! device.is_validated
                });

                if (not_validated_devices.length > 0) {
                    return alert("기존 디바이스의 정보를 입력하세요.");
                }

                let device_data = {};

                if (this.mode == "create") {
                    device_data = { seq_id: moment().valueOf() };
                } else if (this.mode == "edit") {
                    device_data = {
                        device_environment_id: this.project.project_target,
                        id: "",
                        related_id: this.project_id,
                        related_with: "project",
                        title: ""
                    };
                }
                console.log(1111111);
                this.devices.push(device_data);
            },
            addAttachment(type) {

                if (this[type + "_max_count"] > this[type + "_count"]) {
                    ++this[type + "_count"];
                }

            },
            addLink() {

                if (this.link_max_count > this.project.link.length) {
                    this.project.link.push("");
                }

            },
            getTimeFormat(time) {
                if(time == "") time = 0;
                var format = '2018-01-01 ' + ("0" + time).slice(-2) + ':00:00';
                return format;
            },
            projectStatusToText(status) {
                let status_text = {
                    request: '심사중',
                    recruiting: '모집중',
                    testing: '진행중',
                    done: '완료'
                }
                return status_text[status];
            },
            validateBeforeSubmit() {

                this.$validator.validateAll().then((result) => {

                    // # 디바이스 유효성을 검사한다.

                    // 1. 디바이스가 최소 하나 이상 생성되어 있어야 한다.
                    let devices = this.$refs.device;

                    // 생성된 디바이스가 하나도 없을 경우
                    if (devices === undefined) {
                        console.log("생성된 디바이스가 하나도 없을 경우");
                        alert("디바이스를 등록하세요.");
                        return false;
                    }

                    // 2. 생성되어 있는 디바이스가 유효성 검사를 통과한 상태여야 한다. is_validated 값이 true 여야 한다.
                    let not_validated_devices = _.filter(devices, (device) => {
                        return ! device.is_validated;
                    })

                    // 생성된 디바이스들 중 유효성 검사를 통과하지 못한 디바이스가 있는 경우
                    if (not_validated_devices.length > 0) {
                        console.log("생성된 디바이스들 중 유효성 검사를 통과하지 못한 디바이스가 있는 경우");
                        console.log(not_validated_devices);
                        alert("디바이스 정보들을 모두 입력하세요.");
                        return false;
                    }

                    if (result) {

                        $("#device-input-wrap").html("");

                        let form_data = $("#project-form").serializeArray();

                        let data = {};

                        _.each(form_data, function(input) {
                            if(input.name.indexOf("[]") > -1) {
                                let name = input.name.substr(0, input.name.length - 2);
                                if (data[name] === undefined) data[name] = [];
                                data[name].push(input.value)
                            } else {
                                data[input.name] = input.value;
                            }
                        });

                        let devices = [];

                        _.each(this.$children, function(device) {

                            if (device.$el._prevClass === "device-component") {

                                devices.push(device.selected_attributes);

                                let input = $("<input type='hidden' name='devices[]' value='" + JSON.stringify(device.selected_attributes)  + "'>");
                                $("#device-input-wrap").append(input);

                            }

                        });

                        data['devices'] = devices;

                        if (this.mode === "create") {
                            $("#project-form").prop('action', '/project')
                        } else if (this.mode === 'edit') {
                            $("#project-form").prop('action', '/project/' + this.project_id)
                        }

                        $("#project-form").submit();

                    }

                });
            },
            deleteProject() {
                if (confirm("정말 삭제하시겠습니까? 프로젝트와 관련된 모든 정보가 삭제됩니다. 실행후 복구할 수 없습니다.")) {

                    $.ajax({
                        url: "/project/" + this.project_id,
                        method: "post",
                        data: { _method: "delete" }
                    }).done((response) => {
                        if (response.error == "") {
                            this.$emit('deleted');
                            location.reload();
                        } else if (response.error == "no_exists_project") {
                            alert("프로젝트가 존재하지 않습니다.");
                        } else if (response.error == "exists_applicants") {
                            alert("지원자가 존재하는 프로젝트는 삭제할 수 없습니다. 관리자에게 문의바랍니다.");
                        } else if (response.error == "can_not_delete_project") {
                            alert("해당 프로젝트를 삭제하는 중 오류가 발생하였습니다.");
                        }
                    })

                }
            },
            now() {
                return moment().format('Y-MM-DD');
            },
            onDeletedDeviceOfCreateMode(seq_id) {
                this.devices = _.filter(this.devices, (device) => {
                    return device.seq_id != seq_id;
                });

                this.$forceUpdate();
            },
            onDeletedDeviceOfEditMode(device_id) {
                this.devices = _.filter(this.devices, (device) => {
                    return device.id != device_id;
                });

                this.$forceUpdate();
            },
            sterilizeLink(link) {
                const regex = /https?:\/\//g;
                let sterilized_link = link.replace(regex, "");
                return "http://" + sterilized_link;
            }
        }
    }
</script>

<style lang="scss">

    [name='project_target'] + span, [name='testing_purpose[]'] + span {
        font-weight: 500;
    }

    .label-title {
        margin-top: 1.6rem;
        margin-bottom: 0.7rem;
    }

    .bar {
        height: 18px;
        background: green;
    }

    .list-group-item > .badge {
        float: right;
    }

    .cov-vue-date {
        display: block !important;
        .datepickbox {
            .cov-datepicker {
                display: block;
                width: 100%;
                height: 34px;
                padding: 6px 12px;
                padding-right: 12px;
                font-size: 14px;
                line-height: 1.42857143;
                color: #555;
                background-color: #fff;
                background-image: none;
                border: 1px solid #ccc !important;
                border-top-color: rgb(204, 204, 204);
                border-right-color: rgb(204, 204, 204);
                border-bottom-color: rgb(204, 204, 204);
                border-left-color: rgb(204, 204, 204);
                border-radius: 4px;
                -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
                box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
                -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
                -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
                transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/Project.vue